import React, { useState, useEffect } from 'react';
import { getTypes } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Container } from '@mui/material';

const Types = () => {
  const { t } = useTranslation('global');

  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchTypes = async() =>{
    const response = await getTypes();
    console.log(response);
    setTypes(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchTypes();
    
    // Listen for refresh event
    const handleRefresh = () => {
      fetchTypes();
    };
    window.addEventListener('refreshTypes', handleRefresh);
    
    return () => {
      window.removeEventListener('refreshTypes', handleRefresh);
    };
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' }

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth maxWidth="xl">
      <DataTable initialData={types} columns={columns} entityName="types" h2={t("list.types")} />
    </Container>
  );
};

export default Types;

